import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_FilterItem = _resolveComponent("FilterItem")!
  const _component_DanhMucToaXeSearchInput = _resolveComponent("DanhMucToaXeSearchInput")!
  const _component_PageHeaderFilters = _resolveComponent("PageHeaderFilters")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_PageHeaderActionItem = _resolveComponent("PageHeaderActionItem")!
  const _component_PageHeaderActions = _resolveComponent("PageHeaderActions")!
  const _component_KeHoachTable = _resolveComponent("KeHoachTable")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!

  return (_openBlock(), _createBlock(_component_PageContentBase, null, {
    default: _withCtx(() => [
      _createVNode(_component_PageHeaderFilters, null, {
        default: _withCtx(() => [
          (_ctx.isCompanyLevel)
            ? (_openBlock(), _createBlock(_component_FilterItem, {
                key: 0,
                label: "Đơn vị"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.selectedDonViId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDonViId) = $event)),
                    class: "min-w-[12rem]",
                    filterable: "",
                    placeholder: "Chọn đơn vị"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Tất cả",
                        value: ''
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.donViOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.ten_don_vi,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_FilterItem, { label: "Nhóm toa xe" }, {
            default: _withCtx(() => [
              _createVNode(_component_DanhMucToaXeSearchInput, {
                "full-width": "",
                id: _ctx.dmToaXeId || null,
                "display-label": _ctx.selectedDmToaXeLabel,
                onClear: _ctx.handleDmClear,
                onSelect: _ctx.handleDmSelect
              }, null, 8, ["id", "display-label", "onClear", "onSelect"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_PageHeaderActions, null, {
        default: _withCtx(() => [
          _createVNode(_component_PageHeaderActionItem, { onClick: _ctx.openPrintViewer }, {
            icon: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: _ctx.faPrint }, null, 8, ["icon"])
            ]),
            default: _withCtx(() => [
              _createTextVNode(" Xem danh sách kế hoạch sửa chữa (PDF) ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_KeHoachTable, {
        "cur-page": _ctx.currentPage,
        items: _ctx.keHoachItems,
        "per-page": _ctx.perPage
      }, null, 8, ["cur-page", "items", "per-page"]),
      (_ctx.keHoachItems.length > 0)
        ? (_openBlock(), _createBlock(_component_Pagination, {
            key: 0,
            page: _ctx.currentPage,
            "page-size": _ctx.perPage,
            total: _ctx.totalItems,
            onChangePage: _cache[1] || (_cache[1] = (value) => (_ctx.currentPage = value)),
            onChangePageSize: _cache[2] || (_cache[2] = (value) => (_ctx.perPage = value))
          }, null, 8, ["page", "page-size", "total"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}